import React from 'react';
import { SlideLayout } from './SlideLayout';
import { UserX, Activity, BarChart3 } from 'lucide-react';
export function Slide2_Problem() {
  const columns = [{
    icon: UserX,
    title: 'Wrong People In / Right People Out',
    points: ['Late filtering', 'Early drop-off', 'Fast churn']
  }, {
    icon: Activity,
    title: 'Wasted Leadership Bandwidth',
    points: ['Unqualified interviews', 'Fixing hires vs. building teams', 'Recruiting as a scramble']
  }, {
    icon: BarChart3,
    title: 'No Predictability = No Scale',
    points: ['Rollercoaster performance', 'No visibility', 'Culture erosion']
  }];
  return <SlideLayout data-id="element-137" data-mp="2gpe0euj0yrid">
      <div className="flex flex-col h-full justify-center space-y-16" data-id="element-138" data-mp="2gouhbahn1x2r">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-139" data-mp="1szjnkcyph2y4">
          Where Recruiting Actually Breaks
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-140" data-mp="1oxontcwfaxmg">
          {columns.map((col, idx) => <div key={idx} className="bg-slate-900/50 p-8 rounded-xl border border-slate-800 backdrop-blur-sm" data-id="element-141" data-mp="1bdoyo9i1kafe" data-mpi={idx}>
              <div className="h-12 w-12 bg-slate-800 rounded-lg flex items-center justify-center mb-6 text-[#7FE0C3]" data-id="element-142" data-mp="1l4b97pawiar8">
                <col.icon size={24} data-id="element-143" data-mp="1q3e2ydlfkujw" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-6 min-h-[3.5rem]" data-id="element-144" data-mp="1q4yvjxo6q3f4">
                {col.title}
              </h3>
              <ul className="space-y-4" data-id="element-145" data-mp="xdxe1px0rvsf">
                {col.points.map((point, pIdx) => <li key={pIdx} className="flex items-start text-slate-400" data-id="element-146" data-mp="12d0knesnea2i" data-mpi={pIdx}>
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 rounded-full bg-slate-600 flex-shrink-0" data-id="element-147" data-mp="17cmwbjstvi97" />
                    <span className="leading-relaxed" data-id="element-148" data-mp="2dsp6u3y2v529">{point}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </SlideLayout>;
}